export const entries = [
	[
		{
			title: "Sonoma County Rises",
			thumbnail: "https://s3-us-west-1.amazonaws.com/vital38-assets/portfolio/socorises-vector-low-poly.svg",
			link: "https://sonomacountyrises.org"
		},
		{
			title: "Keegan Donley",
			thumbnail: "https://s3-us-west-1.amazonaws.com/vital38-assets/portfolio/keegan-vector-low-poly.svg",
			link: "http://keegandonley.com"
		},
	],
	[
		{
			title: 'Vital 38 Media',
			thumbnail: "https://s3-us-west-1.amazonaws.com/vital38-assets/portfolio/vital38-vector-low-poly.svg",
			link: "#home"
		},
		{
			title: "DKKD Staffing",
			thumbnail: "https://s3-us-west-1.amazonaws.com/vital38-assets/portfolio/dkkd-vector-low-poly.svg",
			link: "http://dkkdstaffing.com"
		},
	],
	[
		{
			title: "TimeoutJs",
			thumbnail: "https://s3-us-west-1.amazonaws.com/vital38-assets/portfolio/timeoutjs-vector-low-poly.svg",
			link: "http://timeoutjs.io"
		},
		{
			title: "TextupJS",
			thumbnail: "https://s3-us-west-1.amazonaws.com/vital38-assets/portfolio/textupjs-vector-low-poly.svg",
			link: "http://textupjs.com"
		},
	],
];


// WEBPACK FOOTER //
// ./src/config/portfolio.js